<match-wrapper
    label="{{ label }}"
    objectType="{{ objectType }}"
    fieldName="{{ fieldName }}"
    (onRemoveMatch)="removeMatch()"
    [showRemoveIcon]="!disabled"
    provideParentForm
>
    <div>
        <label
            aviLabelWithTooltip
            objectType="{{ matchObjectType }}"
            fieldName="match_criteria"
            required
        >
            {{ globalL10nKeys.criteriaLabel | vtranslate }}
        </label>
        <avi-enum-dropdown
            enum="HdrMatchOperation"
            id="{{ 'host-hdr-match-with-objects_match_criteria_' + fieldName + '_' + index }}"
            name="{{ 'host-hdr-match-with-objects_match_criteria_' + fieldName + '_' + index }}"
            [(ngModel)]="config.match_criteria"
            (ngModelChange)="handleCriteriaChange()"
            placeholder="{{ globalL10nKeys.selectCriteriaPlaceholder | vtranslate }}"
            [disabled]="disabled"
            required
        ></avi-enum-dropdown>
    </div>
    <div
        *ngIf="showValueField"
        class="host-hdr-match-with-objects__value-container"
    >
        <label
            aviLabelWithTooltip
            objectType="{{ matchObjectType }}"
            fieldName="value"
            for="value"
            required
        >
            {{ globalL10nKeys.valueLabel | vtranslate }}
        </label>
        <avi-repeated-strings
            id="{{ 'host-hdr-match-with-objects_value_' + fieldName + '_' + index }}"
            name="{{ 'host-hdr-match-with-objects_value_' + fieldName + '_' + index }}"
            placeholder="{{ l10nKeys.enterValuesLabel | vtranslate }}"
            objectType="{{ matchObjectType }}"
            fieldName="value"
            [(ngModel)]="config.value"
            [disabled]="disabled"
            required
        ></avi-repeated-strings>
    </div>
</match-wrapper>
